import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import { GridTwoByTwoItemProps } from '@zola/zola-ui/src/components/PreAuthV3/GridTwoByTwo';

import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';

import GridItem2 from '../../../public/static-preauth/images/WeddingWebsiteLP/V3/Grid/GridV2/GridItem2.webp';
import GridItem3 from '../../../public/static-preauth/images/WeddingWebsiteLP/V3/Grid/GridV2/GridItem3.webp';
import GridItem4 from '../../../public/static-preauth/images/WeddingWebsiteLP/V3/Grid/GridV2/Website_Personalize_desktop@2x.webp';
import GridItem4M from '../../../public/static-preauth/images/WeddingWebsiteLP/V3/Grid/GridV2/Website_Personalize_mobile@2x.webp';

const ONBOARDING_URL = '/wedding/onboard/wedding-website';

export const gridItems: GridTwoByTwoItemProps[] = [
  {
    copy: {
      header: 'Designer templates, no tech skills needed',
      body: 'A wide range of designs, ready for you to customize and share.',
    },
    href: '/wedding-planning/website/designs',
    isAssetVideo: true,
    linkText: 'Explore designs',
    video: {
      src: `${process.env.ASSET_PATH}/static-preauth/images/WeddingWebsiteLP/V3/Grid/GridV2/GridItem1.mp4`,
    },
  },
  {
    copy: {
      header: 'Websites loved by couples and guests',
      body: "It's the easiest way to keep guests updated and for them to RSVP and shop your registry.",
    },
    href: ONBOARDING_URL,
    linkText: 'Start website',
    image: {
      background: {
        parameters: {
          color: COLORS3.WHITE_100,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem2,
        imgType: 'png',
        mobileSrc: GridItem2,
        tabletSrc: GridItem2,
        alt: 'Viewing Zola.com on mobile',
        loading: 'lazy',
      },
    },
  },
  {
    image: {
      background: {
        parameters: {
          color: COLORS3.WHITE_100,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem3,
        imgType: 'png',
        mobileSrc: GridItem3,
        tabletSrc: GridItem3,
        alt: 'Matching Zola invitation and website design',
        loading: 'lazy',
      },
    },
    copy: {
      header: 'Match your wedding invitations and save the dates',
      body: 'Whatever your style, our websites are made to match your invites and more.',
    },
    href: '/wedding-planning/invitations/shop',
    linkText: 'Explore invitations',
  },
  {
    copy: {
      header: 'Personalize your website with a video and a custom URL',
      body: 'Extra touches to make your wedding website even more unique.',
    },
    href: ONBOARDING_URL,
    linkText: 'Get started',
    image: {
      background: {
        parameters: {
          color: COLORS3.WHITE_100,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem4,
        imgType: 'png',
        mobileSrc: GridItem4M,
        tabletSrc: GridItem4,
        alt: 'Zola website with video header',
        loading: 'lazy',
      },
    },
  },
];
